// You probably don't need to edit this file.

// This is required to include styles in the page
require('../sass/core.scss');
require('../sass/enhanced.scss');

// Include the JS
require('./component.js');



// WEBPACK FOOTER //
// ./js/main.js